

import {computed, onMounted, ref} from 'vue'
import {useToast} from "primevue/usetoast";
import {FilterMatchMode} from "primevue/api";
import moment from "moment";
import theoDoiRepository from "@/services/TheoDoiRepository";
import {TinhTien} from "@/models/tinhTien";
import {DieuTri} from "@/models/dieuTri";
import {values} from "lodash";
import { DoanhThu } from '@/models/doanhThu';
import {DoanhThuCungKy} from "@/models/doanhThuCungKy";
import {Dashboard} from "@/models/dashboard";
import {DashboardDoanhThu} from "@/models/dashboardDoanhThu";
import {useRouter} from "vue-router";
import {useStore} from "vuex";


export default {
  setup: function () {
    const toast = useToast();
    const date = ref();
    const doanhThuCungKy = ref({} as DoanhThuCungKy);
    const tongTien = ref(0);
    const checkSelect = ref(false);
    const doanhThu = ref([] as TinhTien[]);
    const loadingBar = ref(true);
    const dashboard = ref({} as Dashboard);
    const dashboarDoanhThu = ref({} as DashboardDoanhThu);
    const doanhThuCaNam = ref([] as DoanhThu[]);
    const router = useRouter();
    const store = useStore();

    if(!(!!store.state.token)){
      console.log("@@@@@@@@@@@@@@@@#################### send message: ");
      router.push({
        name: 'home'
      });
    }

    theoDoiRepository.dashboardDoanhThu(0,0)
        .then((response) => {
          dashboarDoanhThu.value = response.data;
          tongTien.value = dashboarDoanhThu.value.vienPhi_NgoaiTru + dashboarDoanhThu.value.vienPhi_NoiTru;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail: err.response.data,
            life: 2000
          });
        });

    theoDoiRepository.dashboardCungKy()
        .then((response) => {
          doanhThuCungKy.value = response.data;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail: err.response.data,
            life: 2000
          });
        });

    theoDoiRepository.dsdoanhthu()
        .then((response) => {
          doanhThuCaNam.value = response.data;
          loadingBar.value = false;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail: err.response.data,
            life: 2000
          });
        });

    const totalDataYear = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = doanhThuCaNam.value;
      //console.log("################ loadData data: " + data);
      return {
        labels: data.map(x => x.thang),
        datasets: [
          {
            label: 'Doanh thu năm trước',
            data: data.map(x => x.namTruoc),
            backgroundColor: '#ffdc82',
          },
          {
            label: 'Doanh thu năm nay',
            data: data.map(x => x.namNay),
            backgroundColor: '#82c4ff',
          }
        ]
      }
    });

    const basicOptions = ref(
        {
          plugins: {
            legend: {
              labels: {
                color: '#495057'
              }
            }
          },
          scales: {
            x: {
              ticks: {
                color: '#495057'
              },
              grid: {
                color: '#ebedef'
              }
            },
            y: {
              ticks: {
                color: '#495057'
              },
              grid: {
                color: '#ebedef'
              }
            }
          }
        }
    );
    const selectCalendar = () => {
      console.log("%%%%%%%%%%%%%%%% selectCalendar &&&&&&&&&&& date.value[0]: " + date.value[0]/1000);
      console.log("%%%%%%%%%%%%%%%% selectCalendar &&&&&&&&&&& date.value[1]: " + date.value[1]/1000);
      if((date.value[0] != null)&&(date.value[1] != null)) {
        checkSelect.value = true;
        theoDoiRepository.dashboardDoanhThu(date.value[0]/1000, date.value[1]/1000)
            .then((response) => {
              dashboarDoanhThu.value = response.data;
              tongTien.value = dashboarDoanhThu.value.vienPhi_NgoaiTru + dashboarDoanhThu.value.vienPhi_NoiTru;
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            })
      }};

    const clearCalendar = () => {
        checkSelect.value = false;
        // loadData();
    }
    const options = computed(() => {
      const data = doanhThuCaNam.value;
      return{
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '90%',
            endingShape: 'flat',
            dataLabels: {
              position: "top"
            },
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          align: 'left',
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize:  '13px',
            fontWeight:  'bold',
            fontFamily:  undefined,
            color:  '#263238'
          },
        },
        dataLabels: {
          offsetX: +150,
          style: {
            fontSize: '13px',
            colors: ["#304758"]
          },
          formatter: function (val) {
            return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2, style: 'currency', currency: 'VND' }).format(val);
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2, style: 'currency', currency: 'VND' }).format(val);
            }
          }
        },
        chart: {
          id: 'Thống_kê_doanh_thu',
          //stacked: true
        },
        labels: {
          show: false,
          formatter: function (val) {
            return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2, style: 'currency', currency: 'VND' }).format(val);
          }
        },
        xaxis: {
          categories: data.map(x => x.thang)
        }
      }
    })

    const series = computed(() => {
      const data = doanhThuCaNam.value;
      return [{
        name: 'Doanh thu năm trước',
        data: data.map(x => x.namTruoc)
      },
        {
          name: 'Doanh thu năm nay',
          data: data.map(x => x.namNay)
        },
      ]
    });



    return {
      totalDataYear,
      basicOptions,
      selectCalendar,
      date,
      clearCalendar,
      doanhThuCungKy,
      tongTien,
      doanhThu,
      loadingBar,
      dashboard,
      options,
      series,
      dashboarDoanhThu
    }
  }

}
